import { render, staticRenderFns } from "./jjfaadd.vue?vue&type=template&id=c39eb3f8&scoped=true&"
import script from "./jjfaadd.vue?vue&type=script&lang=js&"
export * from "./jjfaadd.vue?vue&type=script&lang=js&"
import style0 from "./jjfaadd.vue?vue&type=style&index=0&id=c39eb3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39eb3f8",
  null
  
)

export default component.exports